import React, {ChangeEvent, FocusEvent} from 'react';
import {Text, TextInput, InputControlView, TextArea} from '@gravity-ui/uikit';
import styles from './FormInput.module.scss';
import cn from 'classnames';

export interface FormInputProps {
  label?: string;
  placeholder?: string;
  name: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  error?: string | false;
  size?: 's' | 'm' | 'l' | 'xl';
  view?: InputControlView;
  isRequired?: boolean;
  errorPlacement?: 'outside' | 'inside';
  isTextarea?: boolean;
  rows?: number;
  type?: 'text' | 'number';
}

export const FormInput = ({
  label,
  placeholder,
  name,
  value,
  onChange,
  onBlur,
  error,
  size = 'xl',
  view = 'normal',
  errorPlacement = 'inside',
  isRequired = false,
  isTextarea = false,
  rows = 4,
  type = 'text',
}: FormInputProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(e);
  };

  const handleBlur = (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onBlur?.(e);
  };

  return (
    <div className={cn(styles.formInput, isTextarea && styles.textarea)}>
      {label && (
        <Text variant="subheader-1" className={styles.formInputLabel}>
          {label}
          {isRequired && <span className={styles.required}>*</span>}
        </Text>
      )}
      {isTextarea ? (
        <TextArea
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          rows={rows}
          size={size}
          view={view}
          error={error}
          errorPlacement={errorPlacement}
        />
      ) : (
        <TextInput
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          size={size}
          view={view}
          error={error}
          errorPlacement={errorPlacement}
          type={type}
        />
      )}
    </div>
  );
};
